import zip from 'just-zip-it'

import object_keys from './object_keys'
import from_entries from './from_entries'
import to_entries from './to_entries'

export const map_object = <T extends { [ s: string ]: any }, NEW_KEY_TYPE extends string, NEW_VALUE_TYPE>(
	object: T,
	fn: <KEY extends keyof T>(kv: [KEY, T[KEY]]) => [NEW_KEY_TYPE, NEW_VALUE_TYPE]
): { [ s in NEW_KEY_TYPE ]: NEW_VALUE_TYPE } => from_entries(
		to_entries(object).map(fn)
	)

export const map_object_values = <KEY extends string, VALUE, NEW_VALUE_TYPE>(object: { [s in KEY]: VALUE }, fn: (value: VALUE) => NEW_VALUE_TYPE) => map_object(object, ([ key, value ]) => [ key, fn(value) ])

export const async_map_object = async<OLD_KEY extends string, NEW_KEY extends string, OLD_VALUE, NEW_VALUE>(
	object: { [s in OLD_KEY]: OLD_VALUE },
	fn: ([ key, value ]: [ OLD_KEY, OLD_VALUE ]) => Promise<[ NEW_KEY, NEW_VALUE ]>
): Promise<{ [s in NEW_KEY]: NEW_VALUE }> => from_entries(await Promise.all(to_entries(object).map(fn)))

export const async_map_object_values = async<KEY extends string, VALUE, NEW_VALUE_TYPE>(
	object: { [s in KEY]: VALUE },
	fn: (value: VALUE) => Promise<NEW_VALUE_TYPE>
): Promise<{ [s in KEY]: NEW_VALUE_TYPE }> => from_entries(zip(
	object_keys(object),
	await Promise.all(Object.values<VALUE>(object).map(fn))
))

type MapOfAwaitables = {
	[key: string]: PromiseLike<any> | any
}
export const promise_all_object = async <const MAP extends MapOfAwaitables>(
	object: MAP
): Promise<{ [key in keyof MAP]: Awaited<MAP[key]> }> => {
	const promised_results = await Promise.all(Object.values<MAP[keyof MAP]>(object))
	const keys = object_keys(object)

	const result_object = from_entries(zip(keys, promised_results))

	// @ts-expect-error TypeScript isn't sure that this type matches the return type, but I think it does
	return result_object
}
